<template>
  <nav :style="appStyleProps">
    <MarketplaceMobileNav class="marketplace-nav d-lg-none border-bottom border-light">
      <AppNav class="sign-out" :full="true" :hide-app-cta="true" />
    </MarketplaceMobileNav>
    <div class="marketplace-nav d-none d-lg-flex justify-content-end bg-body" :class="{'customized-affiliate': !!affiliateCustomizations}">
      <MarketplaceSidebar :showAppConfigNav="showAppConfigNav" />
      <AppNav class="mx-8 mt-5 sign-out sticky-sign-out text-end" :full="true" :hide-app-cta="true" />
    </div>
  </nav>
</template>

<script>
import AppNav from "~/components/AppNav";
import MarketplaceMobileNav from '~/components/marketplace/MarketplaceMobileNav'
import MarketplaceSidebar from '~/components/marketplace/MarketplaceSidebar'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import AppConfigMobileNav from '~/components/app-config/AppConfigMobileNav.vue'
export default {
  name: "MarketplaceNav",
  props: ['showAppConfigNav'],
  components: {
    MarketplaceSidebar,
    MarketplaceMobileNav,
    AppConfigMobileNav,
    AppNav,
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, ['appStyleProps', 'affiliateCustomizations']),
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-variables';

.marketplace-nav {
  width: 100vw;
  position: fixed;
  z-index: 999; // This value must be higher than it's children's z-index values or children may not appear above other DOM elements

  &.customized-affiliate {
    background: $app-body-background-color !important;
  }
}
</style>
